/* Swiper News */
var swiper = new Swiper(".news-slider", {
    slidesPerView: 1,
    spaceBetween: 40,
    loop: false,
    grabCursor: true,
    speed: 800,
    /*autoplay: {
        delay: 3000,
        pauseOnMouseEnter : true,
        disableOnInteraction: false,
    },*/
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    breakpoints: {
        // when window width is >= 640px
        640: {
            slidesPerView: 2,
            spaceBetween: 40,
        },
        // when window width is >= 769px
        769: {
            slidesPerView: 2,
            spaceBetween: 40,
        },
        // when window width is >= 992px
        992: {
            slidesPerView: 4,
            spaceBetween: 40,
        },
    }
});

/* Swiper Conditionning */
var swiper = new Swiper(".slider-mtconditionning", {
    slidesPerView: 1,
    //centeredSlides: true,
    spaceBetween: 40,
    //loop: true,
    grabCursor: true,
    speed: 800,
    /*autoplay: {
        delay: 3000,
        pauseOnMouseEnter : true,
        disableOnInteraction: false,
    },*/
    navigation: {
        nextEl: ".mtc-next",
        prevEl: ".mtc-prev",
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    breakpoints: {
        // when window width is >= 768px
        768: {
            slidesPerView: 2,
            spaceBetween: 40,
        },
        // when window width is >= 992px
        992: {
            slidesPerView: 2,
            spaceBetween: 40,
        },
        // when window width is >= 1400px
        1400: {
            slidesPerView: 3,
            spaceBetween: 40,
        },
    }
});


var swiper = new Swiper(".slider-ptconditionning", {
    slidesPerView: 1,
    //centeredSlides: true,
    spaceBetween: 40,
    //loop: true,
    grabCursor: true,
    speed: 800,
    /*autoplay: {
        delay: 3000,
        pauseOnMouseEnter : true,
        disableOnInteraction: false,
    },*/
    navigation: {
        nextEl: ".ptc-next",
        prevEl: ".ptc-prev",
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    breakpoints: {
        // when window width is >= 768px
        768: {
            slidesPerView: 2,
            spaceBetween: 40,
        },
        // when window width is >= 992px
        992: {
            slidesPerView: 2,
            spaceBetween: 40,
        },
        // when window width is >= 1400px
        1400: {
            slidesPerView: 3,
            spaceBetween: 40,
        },
    }
});



var swiper = new Swiper(".slider-bvconditionning", {
    slidesPerView: 1,
    //centeredSlides: true,
    spaceBetween: 40,
    //loop: true,
    grabCursor: true,
    speed: 800,
    /*autoplay: {
        delay: 3000,
        pauseOnMouseEnter : true,
        disableOnInteraction: false,
    },*/
    navigation: {
        nextEl: ".bv-next",
        prevEl: ".bv-prev",
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    breakpoints: {
        // when window width is >= 768px
        768: {
            slidesPerView: 2,
            spaceBetween: 40,
        },
        // when window width is >= 992px
        992: {
            slidesPerView: 2,
            spaceBetween: 40,
        },
        // when window width is >= 1400px
        1400: {
            slidesPerView: 3,
            spaceBetween: 40,
        },
    }
});


/* Swiper Formules */

var swiper = new Swiper(".slider-bdformules", {
    slidesPerView: 1,
    spaceBetween: 40,
    //loop: true,
    grabCursor: true,
    speed: 800,
    autoplay: {
        delay: 5000,
        pauseOnMouseEnter : true,
        disableOnInteraction: false,
    },
    navigation: {
        nextEl: ".bdf-next",
        prevEl: ".bdf-prev",
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    breakpoints: {
        // when window width is >= 640px
        640: {
            slidesPerView: 2,
            spaceBetween: 40,
        },
        // when window width is >= 769px
        769: {
            slidesPerView: 2,
            spaceBetween: 40,
        },
        // when window width is >= 992px
        1200: {
            slidesPerView: 3,
            spaceBetween: 40,
        },
        // when window width is >= 1700px
        1700: {
            slidesPerView: 4,
            spaceBetween: 40,
        },
    }
});



/* Swiper Missions */

var swiper = new Swiper(".slider-missions", {
    slidesPerView: 1,
    spaceBetween: 10,
    //loop: true,
    grabCursor: true,
    speed: 800,
    autoplay: {
        delay: 5000,
        pauseOnMouseEnter : true,
        disableOnInteraction: false,
    },
    navigation: {
        nextEl: ".missions-next",
        prevEl: ".missions-prev",
    },
    /*pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },*/
    breakpoints: {
        // when window width is >= 640px
        640: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
        // when window width is >= 769px
        769: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
        // when window width is >= 992px
        1400: {
            slidesPerView: 3,
            spaceBetween: 20,
        },
    }
});


/* Swiper Valeurs */

var swiper = new Swiper(".slider-values", {
    slidesPerView: 1,
    spaceBetween: 10,
    //loop: true,
    grabCursor: true,
    speed: 800,
    autoplay: {
        delay: 5000,
        pauseOnMouseEnter : true,
        disableOnInteraction: false,
    },
    navigation: {
        nextEl: ".values-next",
        prevEl: ".values-prev",
    },
    /*pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },*/
    breakpoints: {
        // when window width is >= 640px
        640: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
        // when window width is >= 769px
        769: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
        // when window width is >= 992px
        1400: {
            slidesPerView: 3,
            spaceBetween: 20,
        },
    }
});


/* Swiper Certifications */

var swiper = new Swiper(".slider-certifications", {
    slidesPerView: 1,
    spaceBetween: 0,
    //loop: true,
    grabCursor: true,
    speed: 800,
    autoplay: {
        delay: 5000,
        pauseOnMouseEnter : true,
        disableOnInteraction: false,
    },
    /*navigation: {
        nextEl: ".certifications-next",
        prevEl: ".certifications-prev",
    },*/
    pagination: {
        el: ".certifications-pagination",
        clickable: true,
    },
    breakpoints: {
        // when window width is >= 640px
        640: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
        // when window width is >= 769px
        992: {
            slidesPerView: 1,
            spaceBetween: 20,
        },
        // when window width is >= 992px
        1200: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
        // when window width is >= 992px
        1700: {
            slidesPerView: 3,
            spaceBetween: 20,
        },
    }
});


/* Swiper Offres */

var swiper = new Swiper(".slider-offres", {
    slidesPerView: 1,
    spaceBetween: 10,
    //loop: true,
    grabCursor: true,
    speed: 800,
    autoplay: {
        delay: 5000,
        pauseOnMouseEnter : true,
        disableOnInteraction: false,
    },
    navigation: {
        nextEl: ".offers-next",
        prevEl: ".offers-prev",
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    breakpoints: {
        // when window width is >= 640px
        640: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
        // when window width is >= 769px
        769: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
        // when window width is >= 992px
        992: {
            slidesPerView: 3,
            spaceBetween: 20,
        },
        // when window width is >= 1600px
        1800: {
            slidesPerView: 4,
            spaceBetween: 20,
        },
    }
});


/* Swiper Recrutement */

var swiper = new Swiper(".slider-recrutement", {
    spaceBetween: 10,
    grabCursor: true,
    speed: 800,
    autoplay: {
        delay: 5000,
        pauseOnMouseEnter : true,
        disableOnInteraction: false,
    },
    pagination: {
        el: ".swiper-pagination-custom",
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + (index + 1) + "</span>";
        },
      },
});


/* Swiper Awards */

var swiper = new Swiper(".slider-awards", {
    slidesPerView: 1,
    spaceBetween: 10,
    //loop: true,
    grabCursor: true,
    speed: 800,
    autoplay: {
        delay: 5000,
        pauseOnMouseEnter : true,
        disableOnInteraction: false,
    },
    pagination: {
        el: ".swiper-pagination-awards",
        clickable: true,
    },
    breakpoints: {
        // when window width is >= 767px
        767: {
            slidesPerView: 2
            ,
            spaceBetween: 40,
        },
        // when window width is >= 992px
        992: {
            slidesPerView: 3
            ,
            spaceBetween: 40,
        },
        // when window width is >= 1024px
        1024: {
            slidesPerView: 3,
            spaceBetween: 40,
        },
    }
});